export default "__VITE_ASSET__DOuWbavE__"